export enum MainModules {
  STORES = 'store',
  USERS = 'user',
  LOTTERY = 'lottery',
  BRAND = 'brand',
  STORE_LOTTERY = 'store_lottery',
  REPORTS = 'report',
  SHIFT_CONFIG = 'shift_config',
  SALES = 'shift_config',
  LOSS = 'loss',
  DROPS = 'drops_create',
  SHIFT_REPORT = 'shift_report',
  DAY_REPORT = 'day_report',
  GAS_REPORT = 'gas_report',
  SHIFT_REPORT_CREATE = 'create_shift_report',
  SHIFT_REPORT_UPDATE = 'modify_shift_report',
  MO_ORDER_CONFIG = 'money_order_setup',
  TAX_CONFIG = 'tax_config',
}

export enum MenuType {
  SWITCH_BRAND = 'switchBrand',
  LOGOUT = 'logout',
  CHANGE_PWD = 'changePwd',
}

export enum ReportCategoryType {
  CATEGORY_GAS_SALES_ENTRY = 'gas_sales_entry',
  CATEGORY_SALES_ENTRY = 'sales_entry',
  CATEGORY_CASH_PO_ENTRY = 'cash_po_entry',
  CATEGORY_CASH_DEPOSIT_ENTRY = 'cash_deposit_entry',
}
